// extracted by mini-css-extract-plugin
module.exports = {"close":"messageModal_close__AMXS_","contentContainer":"messageModal_contentContainer__FlDbp","content":"messageModal_content__skoIO"};